import { render } from "./LabSurveys.vue?vue&type=template&id=0672d44d&scoped=true"
import script from "./LabSurveys.vue?vue&type=script&lang=js"
export * from "./LabSurveys.vue?vue&type=script&lang=js"

import "./LabSurveys.vue?vue&type=style&index=0&id=0672d44d&lang=scss&scoped=true"
import "./LabSurveys.vue?vue&type=style&index=1&id=0672d44d&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0672d44d"]])

export default __exports__